<template>
	<Loader v-if="loading" />
	<div v-else class="tags">
		<div
			class="tag"
			v-on:click="toggle(tag)"
			v-for="tag in tags"
			v-bind:class="{active: isTagged(tag)}">
				{{ tag.tag }}
		</div>
	</div>
</template>

<style lang="less" scoped>
	.tags {
		.tag {
			cursor: pointer;
			&.active {
				background: #2f3239;
				color: #fff;
			}
		}
	}
</style>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  props: [
    'tag-type',
    'selection-type',
    'excluded-tags'
  ],
  data: () => ({
    loading: false,
    saving: false,
    data: [],
    tags: [],
    originalTags: [],
  }),
  watch: {
    excludedTags(excludedTags) {
      if (excludedTags !== undefined) {
        this.tags = this.originalTags.filter(
          obj1 => !excludedTags.some(obj2 => obj1.id === obj2.tag_id)
        );
      }
    }
  },
  computed: {
    ...mapGetters([
      'getTags'
    ])
  },
  methods: {
    isTagged (tag) {
      for (var t of this.data) {
        if (t.tag_id === tag.id) {
          return true
        }
      }

      return false
    },
    toggle (tag) {
      if (this.selectionType === 'multiple') {
        this.handleMultiple(tag)
      } else {
        this.data = [];
        this.data.push({ tag_id: tag.id })
      }
      this.$emit('tag-selected', this.data)
    },
    handleMultiple(tag) {
      if (this.isTagged(tag)) {
        this.data.splice(
          this.data.findIndex(row => row.tag_id === tag.id),
          1
        )
      } else {
        this.data.push({ tag_id: tag.id })
      }
    }
  },
  mounted: function() {
    if (this.tagType === 'season') {
      this.originalTags = this.getTags.filter((tag) => {
        return tag.tag.includes("Season")
      })
    } else if (this.tagType === 'non-season') {
      this.originalTags = this.getTags.filter((tag) => {
        return !tag.tag.includes("Season")
      })
    } else {
      this.originalTags = this.getTags
    }
    this.tags = this.originalTags;
  }
}
</script>
